/// <reference path="../../../../WebUI/typings/tsd.d.ts" />
import * as React from "react";
import { BotTabs } from "./BotPage";

export interface TabProps {
    label: string;
    tab: BotTabs;
}

export interface TabControlProps extends React.Props<TabControl> {
    tabs: TabProps[],
    selectedTab: BotTabs;
    className?: string;
    tabClassName?: string;
    selectedClassName?: string;
    botId: string;
    /** event handler for tab clicks */
    clickHandler: (index: BotTabs) => void;
}

export class TabControl extends React.Component<TabControlProps, {}> {
    constructor(props: TabControlProps) {
        props.className = props.className || 'tabl-control';
        props.tabClassName = props.tabClassName || 'tab-control-tab';
        props.selectedClassName = props.selectedClassName || 'selected-tab';
        super(props);
    }

    private onTabClicked(event: React.MouseEvent<HTMLAnchorElement>, tab: BotTabs) {
        event.preventDefault();
        this.setState({ selectedTab: tab });
        if (typeof(this.props.clickHandler) === 'function')
            this.props.clickHandler(tab);
    }

    public render(): JSX.Element {
        let tabs = this.props.tabs.map((tab) => {
            let classes = this.props.tabClassName;
            if (tab.tab === this.props.selectedTab)
                classes += " " + this.props.selectedClassName;
            const href = `/bots/${BotTabs[tab.tab].toLowerCase()}?id=${this.props.botId}`; // href is for show, navigation is handled by onTabClicked function
            return (
                <a key={tab.tab} ref={'tab' + tab.tab} href={href} className={classes} onClick={(event: React.MouseEvent<HTMLAnchorElement>) => this.onTabClicked(event, tab.tab)}>{tab.label}</a>
            );
        });

        return <div className={this.props.className}>{tabs}{this.props.children}</div>;
    }
}



// WEBPACK FOOTER //
// ./Client/v4/Views/TabControl.tsx